/* Coisa Esperta: comportamento da vitrine (home e coleção). Tudo por delegação no document, então continua
   funcionando quando a seção é recarregada pelo editor ou pelo "Carregar mais".
   - Faixas de produto (sections/ce-espertas, formato faixa): setas do computador rolam ~1 tela; seta some no fim.
   - "Carregar mais" (sections/main-collection-product-grid): busca a próxima página só da seção e emenda os cards.
     Sem JS (ou se der erro), o botão é um link normal pra próxima página.
   - Gaveta "Filtrar e ordenar" (snippets/ce-filtros): <dialog> abre/fecha; tocar fora fecha.
   - "+ Adicionar" das faixas ([data-ce-add], snippets/tw-rail-card): /cart/add.js com as seções da gaveta, redesenha
     e abre a gaveta (assets/cart-drawer.js). Sem gaveta ou com erro: vai pra página do produto. */
(() => {
  if (window.ceLoja) return;
  window.ceLoja = true;

  const setas = (lista) => {
    const rail = lista.closest('.ce-rail');
    if (!rail) return;
    const fim = lista.scrollWidth - lista.clientWidth - 4;
    rail.querySelectorAll('[data-ce-rail]').forEach((b) => {
      b.disabled = b.dataset.ceRail === '-1' ? lista.scrollLeft <= 4 : lista.scrollLeft >= fim;
    });
    rail.classList.toggle('ce-rail--rola', lista.scrollWidth > lista.clientWidth + 4);
  };
  const todasSetas = () => document.querySelectorAll('.ce-rail .tw-rail__list').forEach(setas);

  document.addEventListener(
    'scroll',
    (e) => {
      if (e.target instanceof Element && e.target.matches('.ce-rail .tw-rail__list')) setas(e.target);
    },
    { capture: true, passive: true }
  );
  window.addEventListener('resize', todasSetas, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todasSetas);
  else todasSetas();
  document.addEventListener('shopify:section:load', todasSetas);

  async function carregarMais(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    const wrap = btn.closest('[data-ce-mais-wrap]');
    const grade = document.getElementById('product-grid');
    if (!wrap || !grade) return (location.href = btn.href);
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Carregando…';
    const url = new URL(btn.href, location.href);
    url.searchParams.set('section_id', wrap.dataset.section);
    try {
      const resp = await fetch(url, { credentials: 'same-origin' });
      if (!resp.ok) throw new Error(resp.status);
      const doc = new DOMParser().parseFromString(await resp.text(), 'text/html');
      const novos = [...doc.querySelectorAll('#product-grid > li')];
      if (!novos.length) throw new Error('vazio');
      grade.append(...novos);
      const proximo = doc.querySelector('[data-ce-mais-wrap]');
      if (proximo) wrap.replaceWith(proximo);
      else wrap.remove();
      novos[0].querySelector('a[href]')?.focus({ preventScroll: true });
    } catch (err) {
      location.href = btn.href;
    }
  }

  async function adicionar(btn) {
    const gaveta = document.querySelector('cart-drawer');
    if (!gaveta || typeof gaveta.renderContents !== 'function') return (location.href = btn.dataset.url);
    const rotulo = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adicionando…';
    try {
      const resp = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.ceAdd), quantity: 1 }],
          sections: gaveta.getSectionsToRender().map((s) => s.id),
          sections_url: location.pathname,
        }),
      });
      const estado = await resp.json();
      if (!resp.ok) throw estado;
      gaveta.renderContents(estado);
      btn.textContent = '✓ No carrinho';
      setTimeout(() => {
        btn.textContent = rotulo;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }, 2500);
    } catch (err) {
      location.href = btn.dataset.url;
    }
  }

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;

    const add = t.closest('[data-ce-add]');
    if (add) {
      e.preventDefault();
      if (!add.disabled) adicionar(add);
      return;
    }

    const seta = t.closest('[data-ce-rail]');
    if (seta) {
      const lista = seta.closest('.ce-rail')?.querySelector('.tw-rail__list');
      if (lista) lista.scrollBy({ left: lista.clientWidth * 0.9 * Number(seta.dataset.ceRail), behavior: 'smooth' });
      return;
    }

    const mais = t.closest('[data-ce-mais]');
    if (mais && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      carregarMais(mais);
      return;
    }

    const abre = t.closest('[data-ce-filtros-abre]');
    if (abre) {
      const d = document.getElementById(abre.getAttribute('aria-controls'));
      if (d && typeof d.showModal === 'function') {
        d.showModal();
        document.documentElement.classList.add('ce-trava');
      }
      return;
    }

    const fecha = t.closest('[data-ce-filtros-fecha]');
    if (fecha) {
      fecha.closest('dialog')?.close();
      return;
    }

    // toque no fundo escuro (fora do painel) fecha a gaveta
    if (t.matches('dialog.ce-filtros')) t.close();
  });

  document.addEventListener(
    'close',
    (e) => {
      if (e.target instanceof Element && e.target.matches('dialog.ce-filtros')) document.documentElement.classList.remove('ce-trava');
    },
    true
  );
})();
